module.exports = __webpack_public_path__ + "img/42.fb7c0051.png";